const initializeTopBannerSwiper = () => {
  const topBanner = document.querySelector(".home-top-banner");
  if (!topBanner) return;

  const swiper = new Swiper(".top-banner-swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: false,
    slidesPerView: "auto",
    speed: 1000,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: ".home-top-banner .swiper-button-next",
      prevEl: ".home-top-banner .swiper-button-prev",
    },
  });
};

const initializeBrandSwiper = () => {
  const brandSection = document.querySelector(".home-brands");
  if (!brandSection) return;

  const swiper = new Swiper(".home-brands .brand-swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: true,
    slidesPerView: 2,
    centeredSlides: true,
    speed: 1000,
    spaceBetween: 40,
    breakpoints: {
      500: {
        slidesPerView: 3,
      },
      650: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 8,
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initializeTopBannerSwiper();
  initializeBrandSwiper();
});
